export default "<div #cursor class=\"cursor\"></div>\n"